<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <div class="card-list-heading">
                        <h2 class="text-bold">{{ __('Releases') }}</h2>

                        <div class="d-flex flex-wrap">
                            <router-link
                                class="btn btn-md btn-primary mr-3"
                                to="/release-create"
                            >
                                {{ __('New Release') }}
                            </router-link>
                            <button
                                @click="filter"
                                class="btn btn-md btn-primary mr-3"
                                type="button"
                            >
                                {{ __('Filter') }}
                            </button>

                        

                            <button
                                @click="exportReleases"
                                class="btn btn-md btn-primary"
                                type="button"
                            >
                                {{ __('Export XLS') }}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-row-flex">
                        <span>
                            {{ __('Date from') }}
                        </span>
                        <DateTimePicker
                            :placeholder="__('Select')"
                            @change="formatDateFrom"
                            format="YYYY-MM-DD"
                            name="reportdatefrom"
                            type="date"                            
                            v-model="filters.dateFrom"
                            :max-date="filters.dateTo"
                            value-type="format"
                        />
                    </div>

                                <div class="form-row-flex">
                                <span>
                                    {{ __('Release number') }}
                                </span>
                                <!-- <FormInput
                                    name="release_no"
                                    type="text"
                                    v-model="filters.title"
                                ></FormInput> -->
                                 <Autocomplete
                                    :fetch-callback="$api.autocomplete.releaseDocumentsNumbers"
                                    :placeholder="__('Select')"                                   
                                    @input="(item) => filters.title = item.label!=null?item.label:item"
                                    @selected="(item) => filters.title = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete> 
                            </div>


                        
  <!-- <div class="form-row-flex">
                                <span>
                                    {{ __('Receiver') }}
                                </span>                            
                                    <FormInput   
                                    type="text"
                                    v-model="filters.receiverCustomer"
                                ></FormInput>
                            </div> -->
                            <div class="form-row-flex">
                                <span>
                                    {{ __('Invoice No') }}
                                </span>
                                <!-- <FormInput
                                    name="release_invoice_no"
                                    type="text"
                                    v-model="filters.invoice"
                                ></FormInput> -->

                                 <Autocomplete
                                    :fetch-callback="$api.autocomplete.releaseDocumentsInvoices"
                                    :placeholder="__('Select')"                                 
                                    @input="(item) => filters.invoice = item.label!=null?item.label:item"
                                    @selected="(item) => filters.invoice = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete> 
                            </div>
                          <div class="form-row-flex">
                                <span>
                                    {{ __('Transport') }}
                                </span>
                                <Autocomplete
                                    :fetch-callback="$api.autocomplete.releaseDocumentsTransports"
                                    :placeholder="__('Select')"                                   
                                    @input="(item) => filters.transport = item.label!=null?item.label:item"
                                    @selected="(item) => filters.transport = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete> 
                                   <!-- <FormInput
                                  
                               
                                    type="text"
                                    v-model="filters.transport"
                                ></FormInput> -->
                            </div>

                          
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                         <div class="form-row-flex">
                        <span>
                            {{ __('Date to') }}
                        </span>
                        <DateTimePicker
                            :placeholder="__('Select')"
                            @change="formatDateTo"
                            format="YYYY-MM-DD"
                            name="reportdateto"
                            type="date"
                          
                            v-model="filters.dateTo"
                            :min-date="filters.dateFrom"
                            value-type="format"
                        />
                    </div>      
                        <div class="form-row-flex">
                                <span>
                                    {{ __('Date of receipt') }}
                                </span>
                                <DateTimePicker
                                    :placeholder="__('Select')"
                                      @change="formatReceiveDate"
                                    format="YYYY-MM-DD"
                                    name="invoice_date_of_receipt"
                                    type="date"                                    
                                    v-model="filters.date"
                                    value-type="format"
                                />
                            </div>
                              <div class="form-row-flex">
                                <span>
                                    {{ __('Recipient') }}
                                </span>                               
                                   <!-- <FormInput                                  
                               
                                    type="text"
                                    v-model="filters.newReceiverCustomer"
                                ></FormInput> -->
                                 <Autocomplete
                                    :fetch-callback="$api.autocomplete.releaseDocumentsReceivers"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.newReceiverCustomer = item.label!=null?item.label:item"
                                    @selected="(item) => filters.newReceiverCustomer = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div>
                            <div class="form-row-flex">
                                <span>
                                    {{ __('Status') }}
                                </span>
                                <Autocomplete
                                    :fetch-callback="$api.autocomplete.releaseDocumentsStates"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.state = item.label"
                                    @selected="(item) => filters.state = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div>
                            
                       <!--     <div class="form-row-flex">
                                <span>
                                    {{ __('Recipient') }}
                                </span>
                                <Autocomplete
                                        :fetch-callback="$api.autocomplete.releaseDocumentsReceivers"
                                        :placeholder="__('Select recipient')"
                                        @input="(item) => release.receiverCustomer = item.value"
                                        @selected="(item) => release.receiverCustomer = item.value"
                                        value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div>
-->
                          
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-12 card-nopadding">
                            <wi-table
                                :default-params="{ sort: 'createdAt', order: 'desc'}"                             
                                :disable-search="false"
                                :disableHeader="true"
                                :fetch-callback="fetch"     
                                :filters-cleared="clearInputs"                        
                                ref="table"
                            >
                                    <!-- <wi-table-column field="id" sortable>#</wi-table-column>-->
                                      <wi-table-column field="title">{{ __('Release number') }}</wi-table-column>
                                <wi-table-column  field="date"   :render="(column) => moment(column.date).format('YYYY-MM-DD')">{{ __('Date') }}</wi-table-column>
                                  <wi-table-column field="invoice">{{ __('Invoice') }}</wi-table-column>
                                <wi-table-column
                                    class="text-nowrap"
                                    field="receiveDocument"
                                    sortable>
                                    {{ __('Receipt doc.') }}
                                </wi-table-column>
                                <wi-table-column field="receiveDocumentDate"   :render="(column) => moment(column.receiveDocumentDate).format('YYYY-MM-DD')" >{{ __('Arrival date') }}</wi-table-column>    
                                <wi-table-column field="receiveTransport">{{ __('Transport') }}</wi-table-column>                       
                                <wi-table-column field="shipmentKind" sortable>{{ __('Load') }}</wi-table-column>
                                <wi-table-column field="shipmentSize">{{ __('Size') }}</wi-table-column>
                                <wi-table-column field="marking">{{ __('Mark') }}</wi-table-column>
                                <wi-table-column field="lotNo">{{ __('LotNo') }}</wi-table-column>                              
                                <wi-table-column field="senderCustomer">{{ __('Sender') }}</wi-table-column>
                                <wi-table-column field="newReceiverCustomer">{{ __('Recipient') }}
                                </wi-table-column>
                               
                             
                                <wi-table-column field="releaseQuantity">{{ __('Release quantity') }}</wi-table-column>
                                <wi-table-column field="weightBrutto">{{ __('BRUTTO weight') }}</wi-table-column>
                                <wi-table-column field="weightNetto">{{ __('NETTO weight') }}</wi-table-column>  
                                <wi-table-column field="state">{{ __('Status') }}</wi-table-column>
                                <!-- <wi-table-column field="stock">{{ __('Stock') }}</wi-table-column>-->
                                <template slot="actions" slot-scope="{ item }">
                                    <router-link
                                        :to="`/release/${item.id}/edit`"
                                        class="btn btn-data-action btn-sm mr-1"
                                        v-if="item.state === 'Juodraštis' || item.state==='Draft'"
                                    >
                                        {{ __('Edit') }}
                                    </router-link>

                                    <button
                                        @click="remove(item.id)"
                                        class="btn btn-data-action btn-sm"
                                        v-if="item.state === 'Juodraštis' || item.state==='Draft'"
                                    >
                                        {{ __('Delete') }}
                                    </button>

                                    <router-link
                                        :to="`/release/${item.id}/view`"
                                        class="btn btn-data-action btn-sm mr-1"
                                        v-if="item.state === 'Paruošta' || item.state==='Prepared'"
                                    >
                                        {{ __('View') }}
                                    </router-link>
                                     <button
                                        class="btn btn-data-action ml-2"
                                        @click.prevent="attachmentsModal(item)"
                                    >{{ __('Attachments') }}
                                    </button>
                                </template>
                                 
                            </wi-table>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
            <AttachmentsModal ref="modal"></AttachmentsModal>
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
import moment from 'moment'
import { __ } from '../../translations/localization'
import AttachmentsModal from './AttachmentsModal'

import { FilterTable } from '@/mixins/FilterTable'

export default {
  name: 'Releases',

components: {AttachmentsModal},

 mixins: [ FilterTable ],

  data () {
    return {
      release: {
        dateFrom:null,
        dateTo:null,
        date: null,
       
        state: null,
        invoice: null,
        title:null,
        paymentStartDate: null,
        senderCustomer: null,
        newPayerCustomer: null,
        receiverCustomer: null,
        newReceiverCustomer: null
      }, moment
    }
  },

  methods: {
        formatDateFrom (date) {
      this.filters.dateFrom = moment(date).format('YYYY-MM-DDTHH:mm:ss')
      return this.filters.dateFrom
    },

    formatDateTo (date) {
      this.filters.dateTo = moment(date).format('YYYY-MM-DDTHH:mm:ss')
      return this.filters.dateTo
    },
     formatReceiveDate (date) {
      this.filters.date = moment(date).format('YYYY-MM-DDTHH:mm:ss')
      return this.filters.date
    },

    dateFormat (item) {
     return  moment(item.date).format('YYYY-MM-DD')
     
    },

    paymentStartDateFormat (item) {
      return moment(item.paymentStartDate).format('YYYY-MM-DDTHH:mm:ss')
    },

     clearInputs () 
     {     
      this.filters.date = null
    
    },

    fetch (params = []) {
      return this.$api.releases.list(params)
    },

    formatDateOfReceipt (date) {
      this.release.date = moment(date).format('YYYY-MM-DD')
      return this.release.date
    },

    formatDatePaymentStart (date) {
      this.release.paymentStartDate = moment(date).format('YYYY-MM-DD')
      return this.release.paymentStartDate
    },

    exportReleases () {
      return this.$api.releases.download(this.release)
    },
    attachmentsModal (item) {
      this.$refs.modal.show(item.shipmentStockTargetId)
    },
    remove (id) {
      this.$modal.confirm(
        __('Are you sure want to remove this release?'),
        () => {
          return this.$api.releases.delete(id).then(() => {
            this.$toaster.success(__('The release was successfully removed'))
            this.$refs.table.updateTable()
          })
        })
    }
  }
}
</script>
